import { render, staticRenderFns } from "./KeywordModal.vue?vue&type=template&id=33094cfc&"
import script from "./KeywordModal.vue?vue&type=script&lang=js&"
export * from "./KeywordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports